__turbopack_context__.v({
  "adjust": "teacher-workspace-module__zWrcKa__adjust",
  "adjustIcon": "teacher-workspace-module__zWrcKa__adjustIcon",
  "adjustRow": "teacher-workspace-module__zWrcKa__adjustRow",
  "apply": "teacher-workspace-module__zWrcKa__apply",
  "fadeIn": "teacher-workspace-module__zWrcKa__fadeIn",
  "insetIn": "teacher-workspace-module__zWrcKa__insetIn",
  "list": "teacher-workspace-module__zWrcKa__list",
  "pulse": "teacher-workspace-module__zWrcKa__pulse",
  "radio": "teacher-workspace-module__zWrcKa__radio",
  "relight": "teacher-workspace-module__zWrcKa__relight",
  "root": "teacher-workspace-module__zWrcKa__root",
  "routeBody": "teacher-workspace-module__zWrcKa__routeBody",
  "routeNode": "teacher-workspace-module__zWrcKa__routeNode",
  "row": "teacher-workspace-module__zWrcKa__row",
  "rowActive": "teacher-workspace-module__zWrcKa__rowActive",
  "rowIcon": "teacher-workspace-module__zWrcKa__rowIcon",
  "rowText": "teacher-workspace-module__zWrcKa__rowText",
  "segmentOn": "teacher-workspace-module__zWrcKa__segmentOn",
  "segments": "teacher-workspace-module__zWrcKa__segments",
  "sonar": "teacher-workspace-module__zWrcKa__sonar",
});
